export default __webpack_public_path__ + "static/Marlene-McNeese-hero-4eeb5718e233599bcd38bf2ee813ae20.jpg";